<template>
  <div class="et-page">

    <!-- ─── Encabezado: barra sticky que se encoge al hacer scroll ─── -->
    <div class="et-page-header" :class="{ 'et-page-header--scrolled': headerScrolled }">
      <div class="et-page-header-inner">
        <button class="et-back-btn" aria-label="Regresar al Taller Creativo"
          @click="$router.push({ path: '/', hash: '#taller-creativo' })">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div class="et-page-title-area">
          <h1 class="et-page-heading">Etiquetas Escolares</h1>
          <p class="et-page-desc">Diseña e imprime etiquetas personalizadas para útiles, cuadernos y más.</p>
        </div>
        <span class="et-page-chip"><i class="fas fa-wand-magic"></i> Taller Creativo</span>
      </div>
    </div>

    <!-- ─── Cuerpo de página ─── -->
    <div class="et-body-wrap">
    <div class="et-page-body">
      <div class="et-layout">

        <!-- Plantilla + Diseño Aleatorio -->
        <div class="et-topbar">
          <h2 class="et-panel-title">Crear Etiqueta</h2>
          <div class="et-template-row">
            <label for="et-tpl" class="et-small-label">Plantilla:</label>
            <select id="et-tpl" v-model="selectedTemplate" @change="applyTemplate" class="et-select et-select--flex">
              <option value="">— Seleccionar —</option>
              <option v-for="t in TEMPLATES" :key="t.name" :value="t.name">{{ t.name }}</option>
            </select>
            <button type="button" @click="applyRandomDesign" :disabled="!form.nombre.trim()" class="et-btn et-btn--amber">
              Aleatorio
            </button>
          </div>
        </div>

        <!-- Panel Formulario -->
        <div class="et-panel" ref="panelRef">
          <form @submit.prevent="submitForm" class="et-form">

            <!-- Paso 1: Datos del Alumno -->
            <fieldset class="et-fieldset" :class="{ 'et-fieldset--collapsed': openStep !== 1 }">
              <legend class="et-legend" @click="toggleStep(1)">
                <span class="et-step">1</span>Datos del Alumno
                <i class="fas fa-chevron-down et-legend-chevron"></i>
              </legend>
              <div class="et-form-fields">
                <div v-for="f in FIELDS" :key="f.key" class="et-field-block"
                  :class="{ 'et-field-block--open': expandedField === f.key,
                            'et-field-block--collapsed': !openFields[f.key] }">
                  <div class="et-field-head">
                    <button type="button" class="et-collapse-btn" @click="toggleField(f.key)"
                      :aria-expanded="openFields[f.key] ? 'true' : 'false'"
                      :title="(openFields[f.key] ? 'Ocultar ' : 'Mostrar ') + f.label">
                      <i class="fas fa-chevron-down"></i>
                    </button>
                    <label :for="'f-' + f.key" class="et-field-label">
                      {{ f.label }}<span v-if="f.required" class="et-required"> *</span>
                    </label>
                    <button type="button" class="et-style-toggle"
                      :class="{ 'et-style-toggle--active': expandedField === f.key }"
                      @click="toggleFieldStyle(f.key)" :title="'Estilo de ' + f.label">
                      Aa <i class="fas fa-chevron-down"></i>
                    </button>
                  </div>
                  <!-- required solo mientras la card está desplegada: un campo oculto
                       bloquearía el envío sin poder mostrar el mensaje del navegador -->
                  <input :id="'f-' + f.key" type="text" v-model="form[f.key]"
                    :placeholder="f.placeholder" :required="(f.required || false) && openFields[f.key]" class="et-input">
                  <div class="et-field-adv">
                    <input v-if="form[f.showPrefixKey]" type="text" v-model="form[f.prefixKey]"
                      placeholder="Prefijo — Ej: Alumno:" maxlength="20" class="et-input">
                    <div class="et-ctrl-row">
                      <input type="color" v-model="form[f.colorKey]" class="et-color-pick" :title="'Color ' + f.label">
                      <div class="et-align-ctrl">
                        <button type="button" @click="form[f.alignKey] = 'left'"
                          :class="{ 'et-align-active': form[f.alignKey] === 'left' }" class="et-align-btn">L</button>
                        <button type="button" @click="form[f.alignKey] = 'center'"
                          :class="{ 'et-align-active': form[f.alignKey] === 'center' }" class="et-align-btn">C</button>
                        <button type="button" @click="form[f.alignKey] = 'right'"
                          :class="{ 'et-align-active': form[f.alignKey] === 'right' }" class="et-align-btn">R</button>
                      </div>
                      <div class="et-size-ctrl">
                        <button type="button" @click="changeSize(f.sizeKey, -1)" class="et-size-btn">−</button>
                        <span class="et-size-val">{{ form[f.sizeKey] }} pt</span>
                        <button type="button" @click="changeSize(f.sizeKey,  1)" class="et-size-btn">+</button>
                      </div>
                    </div>
                    <div class="et-ctrl-row et-ctrl-row--show">
                      <span class="et-show-label">Mostrar:</span>
                      <label :for="'pfx-' + f.key" class="et-inline-label et-line-check">
                        <input type="checkbox" :id="'pfx-' + f.key" v-model="form[f.showPrefixKey]" class="et-checkbox"> Prefijo
                      </label>
                      <label :for="'blank-' + f.key" class="et-inline-label et-line-check" title="Línea para escribir a mano">
                        <input type="checkbox" :id="'blank-' + f.key" v-model="form[f.blankKey]" class="et-checkbox"> Línea
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Imagen -->
                <div class="et-field-block" :class="{ 'et-field-block--collapsed': !openFields.imagen }">
                  <div class="et-field-head">
                    <button type="button" class="et-collapse-btn" @click="toggleField('imagen')"
                      :aria-expanded="openFields.imagen ? 'true' : 'false'"
                      :title="(openFields.imagen ? 'Ocultar ' : 'Mostrar ') + 'Imagen'">
                      <i class="fas fa-chevron-down"></i>
                    </button>
                    <label class="et-field-label">Imagen</label>
                  </div>
                  <div class="et-file-row">
                    <label for="et-img" class="et-file-label">Seleccionar...</label>
                    <input type="file" id="et-img" accept="image/*" class="et-file-hidden" @change="handleImageUpload">
                    <span class="et-file-name">{{ fileName }}</span>
                  </div>
                </div>
              </div>
            </fieldset>

            <!-- Paso 2: Diseño -->
            <fieldset class="et-fieldset" :class="{ 'et-fieldset--collapsed': openStep !== 2 }">
              <legend class="et-legend" @click="toggleStep(2)">
                <span class="et-step">2</span>Diseño de la Etiqueta
                <i class="fas fa-chevron-down et-legend-chevron"></i>
              </legend>
              <div class="et-design-grid">
                <div class="et-design-field">
                  <label class="et-small-label">Color</label>
                  <input type="color" v-model="form.color" class="et-color-full">
                </div>
                <div class="et-design-field">
                  <label class="et-small-label">Ancho (cm)</label>
                  <input type="number" v-model.number="form.ancho" step="0.1" min="1" max="30" required class="et-input">
                </div>
                <div class="et-design-field">
                  <label class="et-small-label">Alto (cm)</label>
                  <input type="number" v-model.number="form.alto" step="0.1" min="1" max="30" required class="et-input">
                </div>
                <div class="et-design-field">
                  <label class="et-small-label">Textura</label>
                  <select v-model="form.textura" class="et-select">
                    <option v-for="tx in TEXTURES" :key="tx.name" :value="tx.value">{{ tx.name }}</option>
                  </select>
                </div>
              </div>
            </fieldset>

            <!-- Acción principal: debajo del paso 2 -->
            <div class="et-form-actions">
              <button v-if="editingIndex !== null" type="button" @click="cancelEdit" class="et-btn et-btn--outline">
                Cancelar
              </button>
              <button type="submit" :disabled="editingIndex === null && etiquetas.length >= MAX" class="et-btn et-btn--primary">
                {{ editingIndex !== null ? 'Actualizar Etiqueta' : etiquetas.length >= MAX ? 'Límite alcanzado' : 'Agregar Etiqueta' }}
              </button>
            </div>
          </form>

          <!-- Indicador de scroll (solo móvil) -->
          <div v-show="showScrollHint" class="et-scroll-hint">
            <i class="fas fa-chevron-down"></i> Desliza para ver más
          </div>
        </div>

        <!-- Vista Previa -->
        <div class="et-preview-col">
          <div class="et-preview-header">
            <h2 class="et-preview-title">Vista Previa</h2>
            <div class="et-preview-controls">
              <button type="button" @click="undoAction" :disabled="!canUndo" class="et-btn et-btn--outline et-btn--sm et-desktop-only">
                Deshacer
              </button>
              <div class="et-cols-ctrl et-desktop-only">
                <label for="et-cols" class="et-small-label">Cols:</label>
                <select id="et-cols" v-model.number="printCols" class="et-select et-select--sm">
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="3">3</option>
                </select>
              </div>
              <button type="button" @click="shareLabels" :disabled="etiquetas.length === 0 || sharing" class="et-btn et-btn--outline et-share-btn" title="Compartir">
                <i :class="sharing ? 'fas fa-spinner fa-spin' : 'fas fa-share-alt'"></i>
                <span class="et-btn-label">{{ sharing ? 'Generando…' : 'Compartir' }}</span>
              </button>
              <button type="button" @click="doPrint" :disabled="etiquetas.length === 0" class="et-btn et-btn--green" title="Imprimir">
                <i class="fas fa-print"></i> <span class="et-btn-label">Imprimir</span>
              </button>
            </div>
          </div>

          <div ref="cardsRef" class="et-cards-grid">
            <!-- Ghost vista previa -->
            <div v-if="draftLabel" class="et-card-wrap" title="Vista previa — haz clic en Agregar para guardar">
              <div class="et-card-toolbar et-card-toolbar--draft">
                <span class="et-toolbar-size">{{ draftLabel.ancho }} × {{ draftLabel.alto }} cm</span>
              </div>
              <div class="et-card-scroll">
              <div class="et-card et-card--draft" :style="cardStyle(draftLabel)">
                <div v-if="hasImage(draftLabel)" class="et-card-img">
                  <img :src="draftLabel.imagen" :alt="draftLabel.nombre">
                </div>
                <div class="et-card-text" :class="{ 'et-card-text--full': !hasImage(draftLabel) }">
                  <template v-for="cf in CARD_FIELDS" :key="cf.key">
                    <p v-if="shouldShow(draftLabel, cf)" class="et-card-row" :style="rowStyle(draftLabel, cf)">
                      <template v-if="!draftLabel[cf.blankKey]">{{ displayVal(draftLabel, cf) }}</template>
                      <template v-else>
                        <span v-if="draftLabel[cf.showPrefixKey] && draftLabel[cf.prefixKey]" style="white-space:nowrap">{{ draftLabel[cf.prefixKey] }}</span>
                        <span class="et-blank-line"></span>
                      </template>
                    </p>
                  </template>
                </div>
              </div>
              </div>
              <p class="et-draft-hint">Vista previa</p>
            </div>

            <!-- Etiquetas guardadas -->
            <div v-for="(lbl, i) in etiquetas" :key="i" class="et-card-wrap">
              <div class="et-card-toolbar">
                <div class="et-toolbar-group">
                  <button type="button" :disabled="i === 0" @click="moveUp(i)" class="et-icon-btn" title="Mover arriba">▲</button>
                  <button type="button" :disabled="i === etiquetas.length - 1" @click="moveDown(i)" class="et-icon-btn" title="Mover abajo">▼</button>
                </div>
                <span class="et-toolbar-size">{{ lbl.ancho }} × {{ lbl.alto }} cm</span>
                <div class="et-toolbar-group">
                  <button type="button" @click="editLabel(i)" class="et-icon-btn" title="Editar">✏️</button>
                  <button type="button" @click="duplicateLabel(i)" class="et-icon-btn" title="Duplicar">📋</button>
                  <button type="button" @click="deleteLabel(i)" class="et-icon-btn et-icon-btn--danger" title="Eliminar">🗑️</button>
                </div>
              </div>
              <div class="et-card-scroll">
              <div class="et-card" :class="{ 'et-card--editing': editingIndex === i }" :style="cardStyle(lbl)">
                <div v-if="hasImage(lbl)" class="et-card-img">
                  <img :src="lbl.imagen" :alt="lbl.nombre">
                </div>
                <div class="et-card-text" :class="{ 'et-card-text--full': !hasImage(lbl) }">
                  <template v-for="cf in CARD_FIELDS" :key="cf.key">
                    <p v-if="shouldShow(lbl, cf)" class="et-card-row" :style="rowStyle(lbl, cf)">
                      <template v-if="!lbl[cf.blankKey]">{{ displayVal(lbl, cf) }}</template>
                      <template v-else>
                        <span v-if="lbl[cf.showPrefixKey] && lbl[cf.prefixKey]" style="white-space:nowrap">{{ lbl[cf.prefixKey] }}</span>
                        <span class="et-blank-line"></span>
                      </template>
                    </p>
                  </template>
                </div>
              </div>
              </div>
            </div>

            <!-- Estado vacío -->
            <div v-if="etiquetas.length === 0 && !draftLabel" class="et-empty">
              <i class="fas fa-tag"></i>
              <p>Completa el formulario para ver la vista previa</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- FAB Agregar/Actualizar etiqueta (solo móvil) -->
    <div class="et-fab-wrap">
      <button v-if="editingIndex !== null" type="button" @click="cancelEdit" class="et-fab et-fab--cancel" title="Cancelar edición">
        <i class="fas fa-times"></i>
      </button>
      <button type="button" @click="submitForm"
        :disabled="editingIndex === null && etiquetas.length >= MAX"
        class="et-fab"
        :title="editingIndex !== null ? 'Actualizar etiqueta' : 'Agregar etiqueta'">
        <i :class="editingIndex !== null ? 'fas fa-check' : 'fas fa-plus'"></i>
      </button>
    </div>

    <!-- Contenedor solo para impresión -->
    <div ref="printRef" class="et-print-container" :style="{ gridTemplateColumns: 'repeat(' + printCols + ', 1fr)' }">
      <div v-for="(lbl, i) in etiquetas" :key="'p' + i">
        <div class="et-card" :style="cardStyle(lbl)">
          <div v-if="hasImage(lbl)" class="et-card-img">
            <img :src="lbl.imagen" :alt="lbl.nombre">
          </div>
          <div class="et-card-text" :class="{ 'et-card-text--full': !hasImage(lbl) }">
            <template v-for="cf in CARD_FIELDS" :key="cf.key">
              <p v-if="shouldShow(lbl, cf)" class="et-card-row" :style="rowStyle(lbl, cf)">
                <template v-if="!lbl[cf.blankKey]">{{ displayVal(lbl, cf) }}</template>
                <template v-else>
                  <span v-if="lbl[cf.showPrefixKey] && lbl[cf.prefixKey]" style="white-space:nowrap">{{ lbl[cf.prefixKey] }}</span>
                  <span class="et-blank-line"></span>
                </template>
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
    </div>

  </div>
</template>

<script>
import { ref, reactive, computed, watch, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { notify, confirmDialog } from '@/composables/useNotify'

const MAX = 10
// Tamaño de letra en puntos (pt), como Word: rango 8–72, paso 1
const FONT_STEP = 1
const MIN_FONT = 8
const MAX_FONT = 72
const DEFAULT_IMAGE = 'https://placehold.co/120x192/e2e8f0/333?text=Imagen'

const FIELDS = [
  { key: 'nombre',      label: 'Nombre',      placeholder: 'Ej: Olivia Martinez', required: true,
    colorKey: 'colorNombre',      sizeKey: 'fontSizeNombre',      alignKey: 'alignNombre',
    prefixKey: 'prefixNombre',    showPrefixKey: 'showPrefixNombre',    blankKey: 'blankLineNombre' },
  { key: 'grado',       label: 'Grado',       placeholder: 'Ej: KINDER 3 B',
    colorKey: 'colorGrado',       sizeKey: 'fontSizeGrado',       alignKey: 'alignGrado',
    prefixKey: 'prefixGrado',     showPrefixKey: 'showPrefixGrado',     blankKey: 'blankLineGrado' },
  { key: 'materia',     label: 'Materia',     placeholder: 'Ej: Matemáticas',
    colorKey: 'colorMateria',     sizeKey: 'fontSizeMateria',     alignKey: 'alignMateria',
    prefixKey: 'prefixMateria',   showPrefixKey: 'showPrefixMateria',   blankKey: 'blankLineMateria' },
  { key: 'turno',       label: 'Turno',       placeholder: 'Ej: Mañana',
    colorKey: 'colorTurno',       sizeKey: 'fontSizeTurno',       alignKey: 'alignTurno',
    prefixKey: 'prefixTurno',     showPrefixKey: 'showPrefixTurno',     blankKey: 'blankLineTurno' },
  { key: 'seccion',     label: 'Sección',     placeholder: 'Ej: A',
    colorKey: 'colorSeccion',     sizeKey: 'fontSizeSeccion',     alignKey: 'alignSeccion',
    prefixKey: 'prefixSeccion',   showPrefixKey: 'showPrefixSeccion',   blankKey: 'blankLineSeccion' },
  { key: 'escuela',     label: 'Escuela',     placeholder: 'Ej: Colegio Nacional',
    colorKey: 'colorEscuela',     sizeKey: 'fontSizeEscuela',     alignKey: 'alignEscuela',
    prefixKey: 'prefixEscuela',   showPrefixKey: 'showPrefixEscuela',   blankKey: 'blankLineEscuela' },
  { key: 'anioEscolar', label: 'Año Escolar', placeholder: `Ej: ${new Date().getFullYear()}-${new Date().getFullYear() + 1}`,
    colorKey: 'colorAnioEscolar', sizeKey: 'fontSizeAnioEscolar', alignKey: 'alignAnioEscolar',
    prefixKey: 'prefixAnioEscolar', showPrefixKey: 'showPrefixAnioEscolar', blankKey: 'blankLineAnioEscolar' },
]

// Display order inside the card
const CARD_FIELDS = [
  { key: 'escuela',     sizeKey: 'fontSizeEscuela',     colorKey: 'colorEscuela',     alignKey: 'alignEscuela',     prefixKey: 'prefixEscuela',     showPrefixKey: 'showPrefixEscuela',     blankKey: 'blankLineEscuela' },
  { key: 'nombre',      sizeKey: 'fontSizeNombre',      colorKey: 'colorNombre',      alignKey: 'alignNombre',      prefixKey: 'prefixNombre',      showPrefixKey: 'showPrefixNombre',      blankKey: 'blankLineNombre',     alwaysShow: true },
  { key: 'grado',       sizeKey: 'fontSizeGrado',       colorKey: 'colorGrado',       alignKey: 'alignGrado',       prefixKey: 'prefixGrado',       showPrefixKey: 'showPrefixGrado',       blankKey: 'blankLineGrado' },
  { key: 'seccion',     sizeKey: 'fontSizeSeccion',     colorKey: 'colorSeccion',     alignKey: 'alignSeccion',     prefixKey: 'prefixSeccion',     showPrefixKey: 'showPrefixSeccion',     blankKey: 'blankLineSeccion' },
  { key: 'turno',       sizeKey: 'fontSizeTurno',       colorKey: 'colorTurno',       alignKey: 'alignTurno',       prefixKey: 'prefixTurno',       showPrefixKey: 'showPrefixTurno',       blankKey: 'blankLineTurno' },
  { key: 'materia',     sizeKey: 'fontSizeMateria',     colorKey: 'colorMateria',     alignKey: 'alignMateria',     prefixKey: 'prefixMateria',     showPrefixKey: 'showPrefixMateria',     blankKey: 'blankLineMateria' },
  { key: 'anioEscolar', sizeKey: 'fontSizeAnioEscolar', colorKey: 'colorAnioEscolar', alignKey: 'alignAnioEscolar', prefixKey: 'prefixAnioEscolar', showPrefixKey: 'showPrefixAnioEscolar', blankKey: 'blankLineAnioEscolar' },
]

const TEMPLATES = [
  { name: 'Escolar clásico',  color: '#dbeafe', ancho: 8.5, alto: 4.5, textura: '',
    colorNombre: '#1e3a8a', colorGrado: '#1d4ed8', colorMateria: '#1e40af',
    fontSizeNombre: 11, fontSizeGrado: 10, fontSizeMateria: 9 },
  { name: 'Cuaderno grande',  color: '#dcfce7', ancho: 10.0, alto: 5.5,
    textura: 'repeating-linear-gradient(45deg,rgba(0,0,0,.05),rgba(0,0,0,.05) 10px,transparent 10px,transparent 20px)',
    colorNombre: '#14532d', colorGrado: '#166534', colorMateria: '#15803d',
    fontSizeNombre: 12, fontSizeGrado: 10, fontSizeMateria: 10 },
  { name: 'Útiles pequeños',  color: '#fef9c3', ancho: 5.0, alto: 3.0, textura: '',
    colorNombre: '#713f12', colorGrado: '#92400e', colorMateria: '#78350f',
    fontSizeNombre: 9, fontSizeGrado: 8, fontSizeMateria: 8 },
  { name: 'Rosa moderno',     color: '#fce7f3', ancho: 8.5, alto: 4.5,
    textura: 'radial-gradient(circle,rgba(0,0,0,.1) 1px,transparent 1px)',
    colorNombre: '#831843', colorGrado: '#9d174d', colorMateria: '#be185d',
    fontSizeNombre: 11, fontSizeGrado: 10, fontSizeMateria: 9 },
  { name: 'Morado vibrante',  color: '#ede9fe', ancho: 8.5, alto: 4.5,
    textura: 'linear-gradient(rgba(0,0,0,.05) 1px,transparent 1px),linear-gradient(to right,rgba(0,0,0,.05) 1px,transparent 1px)',
    colorNombre: '#2e1065', colorGrado: '#4c1d95', colorMateria: '#5b21b6',
    fontSizeNombre: 11, fontSizeGrado: 10, fontSizeMateria: 9 },
]

const TEXTURES = [
  { name: 'Ninguna', value: '' },
  { name: 'Puntos', value: 'radial-gradient(circle,rgba(0,0,0,.1) 1px,transparent 1px)' },
  { name: 'Lunares', value: 'radial-gradient(circle,rgba(0,0,0,.15) 2.5px,transparent 2.5px)' },
  { name: 'Puntos Blancos', value: 'radial-gradient(circle,rgba(255,255,255,.3) 1px,transparent 1px)' },
  { name: 'Lunares Blancos', value: 'radial-gradient(circle,rgba(255,255,255,.55) 2.5px,transparent 2.5px)' },
  { name: 'Rayas Horiz.', value: 'linear-gradient(rgba(0,0,0,.08) 1px,transparent 1px)' },
  { name: 'Rayas Vert.', value: 'linear-gradient(90deg,rgba(0,0,0,.08) 1px,transparent 1px)' },
  { name: 'Cuadrícula', value: 'linear-gradient(rgba(0,0,0,.05) 1px,transparent 1px),linear-gradient(to right,rgba(0,0,0,.05) 1px,transparent 1px)' },
  { name: 'Cuadrícula Gruesa', value: 'linear-gradient(rgba(0,0,0,.09) 2px,transparent 2px),linear-gradient(to right,rgba(0,0,0,.09) 2px,transparent 2px)' },
  { name: 'Líneas Diag.', value: 'repeating-linear-gradient(45deg,rgba(0,0,0,.05),rgba(0,0,0,.05) 10px,transparent 10px,transparent 20px)' },
  { name: 'Diag. Inversas', value: 'repeating-linear-gradient(-45deg,rgba(0,0,0,.05),rgba(0,0,0,.05) 10px,transparent 10px,transparent 20px)' },
  { name: 'Cruces Diag.', value: 'repeating-linear-gradient(45deg,rgba(0,0,0,.05),rgba(0,0,0,.05) 1px,transparent 1px,transparent 7px),repeating-linear-gradient(-45deg,rgba(0,0,0,.05),rgba(0,0,0,.05) 1px,transparent 1px,transparent 7px)' },
  { name: 'Damero', value: 'conic-gradient(rgba(0,0,0,.07) 90deg,transparent 90deg 180deg,rgba(0,0,0,.07) 180deg 270deg,transparent 270deg)' },
  { name: 'Damero Claro', value: 'conic-gradient(rgba(255,255,255,.25) 90deg,transparent 90deg 180deg,rgba(255,255,255,.25) 180deg 270deg,transparent 270deg)' },
  { name: 'Anillos', value: 'radial-gradient(circle at 50% 50%,transparent 3px,rgba(0,0,0,.09) 3px,rgba(0,0,0,.09) 4.5px,transparent 4.5px)' },
  { name: 'Anillos Blancos', value: 'radial-gradient(circle at 50% 50%,transparent 3px,rgba(255,255,255,.4) 3px,rgba(255,255,255,.4) 4.5px,transparent 4.5px)' },
]

function makeDefaultForm() {
  return {
    nombre: '', grado: '', materia: '', turno: '', seccion: '', escuela: '', anioEscolar: '',
    imagen: '', color: '#ffffff', ancho: 8.5, alto: 4.5, textura: '',
    colorNombre: '#1f2937', colorGrado: '#4b5563', colorMateria: '#374151',
    colorTurno: '#374151', colorSeccion: '#4b5563', colorEscuela: '#1f2937', colorAnioEscolar: '#374151',
    fontSizeNombre: 11, fontSizeGrado: 10, fontSizeMateria: 9,
    fontSizeTurno: 9, fontSizeSeccion: 9, fontSizeEscuela: 9, fontSizeAnioEscolar: 8,
    alignNombre: 'center', alignGrado: 'center', alignMateria: 'center',
    alignTurno: 'center', alignSeccion: 'center', alignEscuela: 'center', alignAnioEscolar: 'center',
    prefixNombre: '', prefixGrado: '', prefixMateria: '', prefixTurno: '',
    prefixSeccion: '', prefixEscuela: '', prefixAnioEscolar: '',
    showPrefixNombre: false, showPrefixGrado: false, showPrefixMateria: false,
    showPrefixTurno: false, showPrefixSeccion: false, showPrefixEscuela: false, showPrefixAnioEscolar: false,
    blankLineNombre: false, blankLineGrado: false, blankLineMateria: false,
    blankLineTurno: false, blankLineSeccion: false, blankLineEscuela: false, blankLineAnioEscolar: false,
  }
}

const FONT_KEYS = [
  'fontSizeNombre', 'fontSizeGrado', 'fontSizeMateria', 'fontSizeTurno',
  'fontSizeSeccion', 'fontSizeEscuela', 'fontSizeAnioEscolar',
]

// Etiquetas guardadas antes del cambio a pt traen rem (< 8); 1rem = 12pt
function normalizeFontSizes(lbl) {
  FONT_KEYS.forEach(k => {
    const v = lbl[k]
    if (typeof v === 'number' && v < MIN_FONT) lbl[k] = Math.max(MIN_FONT, Math.round(v * 12))
  })
  return lbl
}

export default {
  name: 'EtiquetasEscolares',
  setup() {
    const etiquetas = ref(JSON.parse(localStorage.getItem('etiquetas') || '[]').map(normalizeFontSizes))
    const editingIndex = ref(null)
    const history = ref([])
    const printCols = ref(2)
    const fileName = ref('Ningún archivo')
    const selectedTemplate = ref('')
    const printRef = ref(null)
    const sharing = ref(false)
    const panelRef = ref(null)
    const cardsRef = ref(null)
    const showScrollHint = ref(false)
    const form = reactive(makeDefaultForm())
    // Acordeón móvil: paso abierto (1–2, 0 = todos cerrados) y campo con estilo expandido
    const openStep = ref(1)
    const expandedField = ref('')
    // Cards del paso 1: solo la primera (Nombre) arranca desplegada
    const openFields = reactive(
      Object.fromEntries(FIELDS.map((f, i) => [f.key, i === 0]).concat([['imagen', false]]))
    )

    function toggleField(key) { openFields[key] = !openFields[key] }
    // El header se compacta al hacer scroll
    const headerScrolled = ref(false)

    function onWindowScroll() { headerScrolled.value = window.scrollY > 20 }

    function toggleStep(n) { openStep.value = openStep.value === n ? 0 : n }
    function toggleFieldStyle(key) { expandedField.value = expandedField.value === key ? '' : key }

    // El indicador "Desliza para ver más" se oculta al llegar al fondo del panel
    function updateScrollHint() {
      const el = panelRef.value
      if (!el) return
      showScrollHint.value = el.scrollHeight - el.scrollTop - el.clientHeight > 24
    }

    onMounted(() => {
      updateScrollHint()
      onWindowScroll()
      if (panelRef.value) panelRef.value.addEventListener('scroll', updateScrollHint, { passive: true })
      window.addEventListener('resize', updateScrollHint)
      window.addEventListener('scroll', onWindowScroll, { passive: true })
    })

    onBeforeUnmount(() => {
      if (panelRef.value) panelRef.value.removeEventListener('scroll', updateScrollHint)
      window.removeEventListener('resize', updateScrollHint)
      window.removeEventListener('scroll', onWindowScroll)
    })

    // Al abrir/cerrar secciones cambia la altura del panel; recalcular el hint
    watch([openStep, expandedField, openFields], () => { nextTick(() => updateScrollHint()) })

    const canUndo = computed(() => history.value.length > 0)

    function buildLabel() {
      return {
        nombre: form.nombre.trim(), grado: form.grado, materia: form.materia,
        turno: form.turno, seccion: form.seccion, escuela: form.escuela, anioEscolar: form.anioEscolar,
        imagen: form.imagen || DEFAULT_IMAGE,
        color: form.color, ancho: form.ancho, alto: form.alto, textura: form.textura,
        colorNombre: form.colorNombre, colorGrado: form.colorGrado, colorMateria: form.colorMateria,
        colorTurno: form.colorTurno, colorSeccion: form.colorSeccion, colorEscuela: form.colorEscuela,
        colorAnioEscolar: form.colorAnioEscolar,
        fontSizeNombre: form.fontSizeNombre, fontSizeGrado: form.fontSizeGrado,
        fontSizeMateria: form.fontSizeMateria, fontSizeTurno: form.fontSizeTurno,
        fontSizeSeccion: form.fontSizeSeccion, fontSizeEscuela: form.fontSizeEscuela,
        fontSizeAnioEscolar: form.fontSizeAnioEscolar,
        alignNombre: form.alignNombre, alignGrado: form.alignGrado, alignMateria: form.alignMateria,
        alignTurno: form.alignTurno, alignSeccion: form.alignSeccion, alignEscuela: form.alignEscuela,
        alignAnioEscolar: form.alignAnioEscolar,
        prefixNombre: form.prefixNombre, prefixGrado: form.prefixGrado, prefixMateria: form.prefixMateria,
        prefixTurno: form.prefixTurno, prefixSeccion: form.prefixSeccion, prefixEscuela: form.prefixEscuela,
        prefixAnioEscolar: form.prefixAnioEscolar,
        showPrefixNombre: form.showPrefixNombre, showPrefixGrado: form.showPrefixGrado,
        showPrefixMateria: form.showPrefixMateria, showPrefixTurno: form.showPrefixTurno,
        showPrefixSeccion: form.showPrefixSeccion, showPrefixEscuela: form.showPrefixEscuela,
        showPrefixAnioEscolar: form.showPrefixAnioEscolar,
        blankLineNombre: form.blankLineNombre, blankLineGrado: form.blankLineGrado,
        blankLineMateria: form.blankLineMateria, blankLineTurno: form.blankLineTurno,
        blankLineSeccion: form.blankLineSeccion, blankLineEscuela: form.blankLineEscuela,
        blankLineAnioEscolar: form.blankLineAnioEscolar,
      }
    }

    const draftLabel = computed(() => {
      if (editingIndex.value !== null || !form.nombre.trim()) return null
      return buildLabel()
    })

    // Live update card while editing
    watch(form, () => {
      if (editingIndex.value !== null) {
        etiquetas.value[editingIndex.value] = buildLabel()
      }
    }, { deep: true })

    watch(etiquetas, () => {
      localStorage.setItem('etiquetas', JSON.stringify(etiquetas.value))
    }, { deep: true })

    function darken(hex, pct) {
      let r = parseInt(hex.slice(1, 3), 16)
      let g = parseInt(hex.slice(3, 5), 16)
      let b = parseInt(hex.slice(5, 7), 16)
      r = Math.min(255, Math.floor(r * (100 - pct) / 100))
      g = Math.min(255, Math.floor(g * (100 - pct) / 100))
      b = Math.min(255, Math.floor(b * (100 - pct) / 100))
      return `#${r.toString(16).padStart(2,'0')}${g.toString(16).padStart(2,'0')}${b.toString(16).padStart(2,'0')}`
    }

    function borderColor(hex) {
      const r = parseInt(hex.slice(1, 3), 16)
      const g = parseInt(hex.slice(3, 5), 16)
      const b = parseInt(hex.slice(5, 7), 16)
      return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.9 ? '#000' : darken(hex, 20)
    }

    function cardStyle(lbl) {
      const bg = lbl.color || '#fff'
      return {
        width: lbl.ancho + 'cm', height: lbl.alto + 'cm',
        backgroundColor: bg, borderColor: borderColor(bg),
        backgroundImage: lbl.textura || '',
        backgroundSize: '10px 10px',
      }
    }

    // Un dato solo aparece en la etiqueta si se escribió (o se pidió línea en blanco)
    function shouldShow(lbl, cf) {
      if (cf.alwaysShow) return true
      return !!(lbl[cf.key] || lbl[cf.blankKey])
    }

    function hasImage(lbl) {
      return !!lbl.imagen && lbl.imagen !== DEFAULT_IMAGE
    }

    function rowStyle(lbl, cf) {
      const blank = lbl[cf.blankKey]
      return {
        fontSize: (lbl[cf.sizeKey] || 9) + 'pt',
        color: lbl[cf.colorKey] || '#1a1a1a',
        textAlign: lbl[cf.alignKey] || 'center',
        width: '100%',
        display: blank ? 'flex' : undefined,
        alignItems: blank ? 'flex-end' : undefined,
        gap: blank ? '4px' : undefined,
      }
    }

    function displayVal(lbl, cf) {
      const val = lbl[cf.key] || ''
      return (lbl[cf.showPrefixKey] && lbl[cf.prefixKey]) ? `${lbl[cf.prefixKey]} ${val}` : val
    }

    function pushHistory() {
      history.value.push(JSON.parse(JSON.stringify(etiquetas.value)))
      if (history.value.length > 10) history.value.shift()
    }

    function resetForm() {
      Object.assign(form, makeDefaultForm())
      fileName.value = 'Ningún archivo'
      selectedTemplate.value = ''
    }

    function submitForm() {
      if (!form.nombre.trim()) {
        openFields.nombre = true
        notify.error('El nombre no puede estar vacío.'); return
      }
      if (editingIndex.value === null && etiquetas.value.length >= MAX) {
        notify.warn('Has alcanzado el límite de 10 etiquetas.'); return
      }
      pushHistory()
      const lbl = buildLabel()
      if (editingIndex.value !== null) {
        etiquetas.value[editingIndex.value] = lbl
        editingIndex.value = null
        notify.success('Etiqueta actualizada')
      } else {
        // Las nuevas van al principio: la última creada se ve primero
        etiquetas.value.unshift(lbl)
        nextTick(() => { if (cardsRef.value) cardsRef.value.scrollTop = 0 })
        notify.success('Etiqueta agregada')
      }
      resetForm()
    }

    function editLabel(i) {
      const lbl = etiquetas.value[i]
      Object.assign(form, {
        nombre: lbl.nombre || '', grado: lbl.grado || '', materia: lbl.materia || '',
        turno: lbl.turno || '', seccion: lbl.seccion || '', escuela: lbl.escuela || '',
        anioEscolar: lbl.anioEscolar || '',
        imagen: lbl.imagen !== DEFAULT_IMAGE ? (lbl.imagen || '') : '',
        color: lbl.color || '#fff', ancho: lbl.ancho || 8.5, alto: lbl.alto || 4.5,
        textura: lbl.textura || '',
        colorNombre: lbl.colorNombre || '#1f2937', colorGrado: lbl.colorGrado || '#4b5563',
        colorMateria: lbl.colorMateria || '#374151', colorTurno: lbl.colorTurno || '#374151',
        colorSeccion: lbl.colorSeccion || '#4b5563', colorEscuela: lbl.colorEscuela || '#1f2937',
        colorAnioEscolar: lbl.colorAnioEscolar || '#374151',
        fontSizeNombre: lbl.fontSizeNombre || 11, fontSizeGrado: lbl.fontSizeGrado || 10,
        fontSizeMateria: lbl.fontSizeMateria || 9, fontSizeTurno: lbl.fontSizeTurno || 9,
        fontSizeSeccion: lbl.fontSizeSeccion || 9, fontSizeEscuela: lbl.fontSizeEscuela || 9,
        fontSizeAnioEscolar: lbl.fontSizeAnioEscolar || 8,
        alignNombre: lbl.alignNombre || 'center', alignGrado: lbl.alignGrado || 'center',
        alignMateria: lbl.alignMateria || 'center', alignTurno: lbl.alignTurno || 'center',
        alignSeccion: lbl.alignSeccion || 'center', alignEscuela: lbl.alignEscuela || 'center',
        alignAnioEscolar: lbl.alignAnioEscolar || 'center',
        prefixNombre: lbl.prefixNombre || '', prefixGrado: lbl.prefixGrado || '',
        prefixMateria: lbl.prefixMateria || '', prefixTurno: lbl.prefixTurno || '',
        prefixSeccion: lbl.prefixSeccion || '', prefixEscuela: lbl.prefixEscuela || '',
        prefixAnioEscolar: lbl.prefixAnioEscolar || '',
        showPrefixNombre: !!lbl.showPrefixNombre, showPrefixGrado: !!lbl.showPrefixGrado,
        showPrefixMateria: !!lbl.showPrefixMateria, showPrefixTurno: !!lbl.showPrefixTurno,
        showPrefixSeccion: !!lbl.showPrefixSeccion, showPrefixEscuela: !!lbl.showPrefixEscuela,
        showPrefixAnioEscolar: !!lbl.showPrefixAnioEscolar,
        blankLineNombre: !!lbl.blankLineNombre, blankLineGrado: !!lbl.blankLineGrado,
        blankLineMateria: !!lbl.blankLineMateria, blankLineTurno: !!lbl.blankLineTurno,
        blankLineSeccion: !!lbl.blankLineSeccion, blankLineEscuela: !!lbl.blankLineEscuela,
        blankLineAnioEscolar: !!lbl.blankLineAnioEscolar,
      })
      fileName.value = (lbl.imagen && lbl.imagen !== DEFAULT_IMAGE) ? 'Imagen cargada' : 'Ningún archivo'
      editingIndex.value = i
      openStep.value = 1
    }

    function cancelEdit() { editingIndex.value = null; resetForm() }

    async function deleteLabel(i) {
      const ok = await confirmDialog({
        title: '¿Eliminar etiqueta?',
        message: `La etiqueta de «${etiquetas.value[i].nombre}» se quitará de la hoja. Podrás deshacer esta acción.`,
        confirmText: 'Eliminar',
        danger: true,
      })
      if (!ok) return
      pushHistory()
      etiquetas.value.splice(i, 1)
      if (editingIndex.value === i) { editingIndex.value = null; resetForm() }
      else if (editingIndex.value !== null && editingIndex.value > i) editingIndex.value--
      notify.info('Etiqueta eliminada', { action: 'Deshacer', onAction: undoAction })
    }

    function duplicateLabel(i) {
      if (etiquetas.value.length >= MAX) { notify.warn('Límite de 10 etiquetas alcanzado.'); return }
      pushHistory()
      etiquetas.value.splice(i + 1, 0, JSON.parse(JSON.stringify(etiquetas.value[i])))
    }

    function moveUp(i) {
      if (i === 0) return; pushHistory()
      ;[etiquetas.value[i - 1], etiquetas.value[i]] = [etiquetas.value[i], etiquetas.value[i - 1]]
      if (editingIndex.value === i) editingIndex.value = i - 1
      else if (editingIndex.value === i - 1) editingIndex.value = i
    }

    function moveDown(i) {
      if (i >= etiquetas.value.length - 1) return; pushHistory()
      ;[etiquetas.value[i], etiquetas.value[i + 1]] = [etiquetas.value[i + 1], etiquetas.value[i]]
      if (editingIndex.value === i) editingIndex.value = i + 1
      else if (editingIndex.value === i + 1) editingIndex.value = i
    }

    function undoAction() {
      if (!history.value.length) return
      etiquetas.value = history.value.pop()
      editingIndex.value = null; resetForm()
    }

    function hslToHex(h, s, l) {
      s /= 100; l /= 100
      const a = s * Math.min(l, 1 - l)
      const f = n => { const k = (n + h / 30) % 12; const c = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1); return Math.round(255 * c).toString(16).padStart(2, '0') }
      return `#${f(0)}${f(8)}${f(4)}`
    }

    function applyRandomDesign() {
      if (!form.nombre.trim()) return
      const h = Math.floor(Math.random() * 360)
      form.color = hslToHex(h, 50 + Math.floor(Math.random() * 35), 83 + Math.floor(Math.random() * 12))
      const ts = 55 + Math.floor(Math.random() * 25)
      form.colorNombre = hslToHex(h, ts, 18); form.colorGrado = hslToHex(h, ts - 10, 30)
      form.colorMateria = hslToHex(h, ts - 5, 24); form.colorEscuela = hslToHex(h, ts, 20)
      form.colorSeccion = hslToHex(h, ts - 10, 30); form.colorTurno = hslToHex(h, ts - 5, 26)
      form.colorAnioEscolar = hslToHex(h, ts - 8, 28)
      const nonEmpty = TEXTURES.filter(t => t.value !== '')
      form.textura = Math.random() > 0.25 ? nonEmpty[Math.floor(Math.random() * nonEmpty.length)].value : ''
      const fn = 10 + Math.floor(Math.random() * 4) // Nombre 10–13pt
      form.fontSizeNombre = fn
      form.fontSizeGrado   = Math.max(MIN_FONT, fn - 1 - Math.floor(Math.random() * 2))
      form.fontSizeMateria = Math.max(MIN_FONT, fn - 2 - Math.floor(Math.random() * 2))
      form.fontSizeEscuela = Math.max(MIN_FONT, fn - 1)
      form.fontSizeSeccion = Math.max(MIN_FONT, fn - 2)
      form.fontSizeTurno   = Math.max(MIN_FONT, fn - 2)
      form.fontSizeAnioEscolar = Math.max(MIN_FONT, fn - 3)
    }

    function applyTemplate() {
      const tpl = TEMPLATES.find(t => t.name === selectedTemplate.value); if (!tpl) return
      Object.assign(form, {
        color: tpl.color, ancho: tpl.ancho, alto: tpl.alto, textura: tpl.textura,
        colorNombre: tpl.colorNombre, colorGrado: tpl.colorGrado, colorMateria: tpl.colorMateria,
        fontSizeNombre: tpl.fontSizeNombre, fontSizeGrado: tpl.fontSizeGrado, fontSizeMateria: tpl.fontSizeMateria,
      })
      selectedTemplate.value = ''
    }

    function handleImageUpload(e) {
      const file = e.target.files[0]; if (!file) return
      const reader = new FileReader()
      reader.onload = ev => {
        form.imagen = ev.target.result
        fileName.value = file.name.length > 28 ? file.name.slice(0, 26) + '…' : file.name
      }
      reader.onerror = () => { notify.error('No se pudo cargar la imagen.'); fileName.value = 'Error'; form.imagen = '' }
      reader.readAsDataURL(file)
    }

    function changeSize(sizeKey, dir) {
      form[sizeKey] = Math.min(MAX_FONT, Math.max(MIN_FONT, form[sizeKey] + dir * FONT_STEP))
    }

    function doPrint() { window.print() }

    // Genera un PNG de las etiquetas y abre la hoja nativa de compartir del
    // smartphone (Web Share API); si el navegador no soporta compartir
    // archivos, descarga el PNG. Requiere HTTPS y un gesto del usuario.
    async function shareLabels() {
      if (!etiquetas.value.length || sharing.value) return
      sharing.value = true
      const el = printRef.value
      try {
        el.classList.add('et-print-container--capture')
        await nextTick()
        const { default: html2canvas } = await import('html2canvas')
        const canvas = await html2canvas(el, { useCORS: true, scale: 2, backgroundColor: '#ffffff' })
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))
        if (!blob) throw new Error('No se pudo generar la imagen')
        const file = new File([blob], 'etiquetas-neliel.png', { type: 'image/png' })
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: 'Etiquetas Escolares' })
        } else {
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url; a.download = 'etiquetas-neliel.png'; a.click()
          URL.revokeObjectURL(url)
          notify.info(window.isSecureContext
            ? 'Este navegador no permite abrir el menú de compartir; se descargó la imagen en su lugar.'
            : 'El menú de compartir solo funciona con HTTPS; como el sitio se abrió sin conexión segura, se descargó la imagen en su lugar.')
        }
      } catch (err) {
        if (!err || err.name !== 'AbortError') notify.error('No se pudieron compartir las etiquetas. Intenta de nuevo.')
      } finally {
        if (el) el.classList.remove('et-print-container--capture')
        sharing.value = false
      }
    }

    return {
      MAX, FIELDS, CARD_FIELDS, TEMPLATES, TEXTURES,
      etiquetas, editingIndex, printCols, fileName, selectedTemplate, form,
      canUndo, draftLabel, printRef, sharing, panelRef, cardsRef, showScrollHint,
      openStep, expandedField, toggleStep, toggleFieldStyle, headerScrolled,
      openFields, toggleField,
      cardStyle, shouldShow, hasImage, rowStyle, displayVal,
      submitForm, editLabel, cancelEdit, deleteLabel, duplicateLabel,
      moveUp, moveDown, undoAction, applyRandomDesign, applyTemplate,
      handleImageUpload, changeSize, doPrint, shareLabels,
    }
  }
}
</script>

<style scoped>
/* ─── Página ─── */
.et-page { min-height: 100vh; background: var(--c-bg, #faf9f7); display: flex; flex-direction: column; }

/* ─── Encabezado: barra sticky que se encoge al hacer scroll ─── */
.et-page-header { position: sticky; top: 0; z-index: 50; background: var(--c-primary, #003b4c); padding: .9rem 0; transition: padding .28s ease, background .28s ease, box-shadow .28s ease; }
.et-page-header--scrolled { background: rgba(0,59,76,.92); backdrop-filter: blur(14px) saturate(1.4); -webkit-backdrop-filter: blur(14px) saturate(1.4); box-shadow: 0 4px 18px rgba(0,10,14,.25); padding: .45rem 0; }
.et-page-header-inner { max-width: 1120px; margin: 0 auto; padding: 0 24px; display: flex; align-items: center; gap: 14px; }
.et-back-btn { flex-shrink: 0; width: 42px; height: 42px; border-radius: 50%; background: rgba(255,255,255,.12); color: #fff; border: 1.5px solid rgba(255,255,255,.3); font-size: .95rem; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background .2s; }
.et-back-btn:hover { background: rgba(255,255,255,.22); }
.et-page-title-area { flex: 1; min-width: 0; }
.et-page-chip { flex-shrink: 0; display: inline-flex; align-items: center; gap: 6px; background: rgba(255,255,255,.15); color: var(--c-peach, #f0c2b2); border-radius: 999px; padding: 3px 12px; font-size: .7rem; font-weight: 800; text-transform: uppercase; letter-spacing: .08em; }
.et-page-heading { font-size: 1.35rem; font-weight: 900; color: #fff; margin: 0; line-height: 1.2; }
.et-page-desc { color: rgba(255,255,255,.7); font-size: .82rem; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-height: 1.6em; transition: max-height .28s ease, opacity .2s ease; }
.et-page-header--scrolled .et-page-desc { max-height: 0; opacity: 0; }

/* ─── Cuerpo ─── */
.et-body-wrap { flex: 1; min-height: 0; padding: 0.75rem; display: flex; flex-direction: column; }
.et-page-body { flex: 1; min-height: 0; max-width: 1120px; margin: 0 auto; width: 100%; padding: 2rem; background: white; border-radius: 16px; border: 1px solid #e2e8f0; box-shadow: 0 8px 32px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.05); overflow: hidden; }
/* grid-template-rows: la vista previa abarca ambas filas; sin una pista flexible
   su excedente se repartiría entre las dos filas auto y empujaría al formulario */
.et-layout { display: grid; grid-template-columns: 420px 1fr; grid-template-rows: auto 1fr; grid-template-areas: "tpl preview" "form preview"; gap: 1rem 2rem; align-items: start; }
.et-layout > * { min-width: 0; }

/* ─── Topbar (Plantilla + Aleatorio) ─── */
.et-topbar { grid-area: tpl; background: #fff; border-radius: 1.5rem; padding: 1.25rem 2rem; box-shadow: var(--sh-md, 0 4px 16px rgba(0,0,0,.08)); border: 1px solid var(--c-border, #e8e4df); font-family: marine, 'Inter', sans-serif; }

/* ─── Panel ─── */
.et-panel { grid-area: form; background: #fff; border-radius: 1.5rem; padding: 1.75rem 2rem; box-shadow: var(--sh-md, 0 4px 16px rgba(0,0,0,.08)); border: 1px solid var(--c-border, #e8e4df); font-family: marine, 'Inter', sans-serif; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none; }
.et-panel::-webkit-scrollbar { display: none; }
.et-panel-title { font-size: 1.1rem; font-weight: 900; color: var(--c-primary); text-transform: uppercase; letter-spacing: .05em; margin: 0 0 1rem; }

/* ─── Formulario ─── */
.et-form { display: flex; flex-direction: column; gap: .75rem; }
.et-template-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.et-fieldset { border: 1px solid var(--c-border, #e8e4df); border-radius: 1rem; padding: 1rem; background: #f8fafc; }
.et-legend { font-size: .65rem; font-weight: 900; text-transform: uppercase; letter-spacing: .1em; color: #64748b; display: flex; align-items: center; gap: 6px; }
.et-step { display: inline-flex; align-items: center; justify-content: center; width: 18px; height: 18px; border-radius: 50%; background: var(--c-primary); color: #fff; font-size: .65rem; font-weight: 900; }
.et-form-fields { display: flex; flex-direction: column; gap: .75rem; margin-top: .75rem; }

/* ─── Field block ─── */
.et-field-block { background: #fff; border: 1px solid var(--c-border, #e8e4df); border-radius: .75rem; padding: .6rem .75rem; }
.et-field-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.et-field-label { display: block; font-size: .65rem; font-weight: 900; text-transform: uppercase; letter-spacing: .08em; color: var(--c-primary); margin-bottom: .3rem; margin-right: auto; }

/* Plegar la card: queda solo el título y su botón, con el mismo ancho */
.et-collapse-btn { flex-shrink: 0; width: 22px; height: 22px; display: inline-flex; align-items: center; justify-content: center; padding: 0; border: 1px solid #d1d5db; border-radius: 6px; background: #fff; color: #64748b; font-size: .6rem; cursor: pointer; transition: background .15s; }
.et-collapse-btn:hover { background: #f1f5f9; }
.et-collapse-btn i { transition: transform .2s; }
.et-field-block--collapsed .et-collapse-btn i { transform: rotate(-90deg); }
.et-field-block--collapsed { padding: .45rem .75rem; }
.et-field-block--collapsed .et-field-label { margin-bottom: 0; }
.et-field-block--collapsed .et-input,
.et-field-block--collapsed .et-field-adv,
.et-field-block--collapsed .et-file-row,
.et-field-block--collapsed .et-style-toggle { display: none; }
/* Toggle "Aa" y chevrones del acordeón: solo existen en móvil */
.et-style-toggle { display: none; }
.et-legend-chevron { display: none; }
.et-required { color: #ef4444; }
.et-input { width: 100%; padding: 7px 10px; border: 1px solid #e2e8f0; border-radius: 8px; font-size: .82rem; font-family: marine, 'Inter', sans-serif; color: #1a1a1a; box-sizing: border-box; transition: border-color .15s; margin-bottom: .4rem; }
.et-input:focus { outline: none; border-color: var(--c-primary); }

/* Fila de controles: color + alineación + tamaño a la misma altura */
.et-ctrl-row { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-top: .4rem; flex-wrap: wrap; }
.et-ctrl-row--show { justify-content: flex-start; gap: 14px; }
.et-show-label { font-size: .65rem; font-weight: 900; text-transform: uppercase; letter-spacing: .08em; color: #64748b; }
.et-color-pick { width: 34px; height: 34px; border: none; border-radius: 6px; cursor: pointer; padding: 2px; flex-shrink: 0; }
.et-size-ctrl { display: flex; align-items: center; gap: 2px; }
.et-size-btn { width: 22px; height: 22px; border: 1px solid #d1d5db; border-radius: 4px; font-size: .85rem; font-weight: 700; display: flex; align-items: center; justify-content: center; cursor: pointer; background: #fff; line-height: 1; }
.et-size-btn:hover { background: #f1f5f9; }
.et-size-val { font-size: .72rem; color: #64748b; width: 44px; text-align: center; font-variant-numeric: tabular-nums; }
.et-align-ctrl { display: flex; border: 1px solid #d1d5db; border-radius: 6px; overflow: hidden; }
.et-align-btn { width: 26px; height: 22px; font-size: .7rem; display: flex; align-items: center; justify-content: center; cursor: pointer; background: #fff; border: none; transition: background .1s; }
.et-align-btn:hover { background: #f1f5f9; }
.et-align-active { background: rgba(0,59,76,.1); color: var(--c-primary); font-weight: 700; }

.et-checkbox { width: 13px; height: 13px; accent-color: var(--c-primary); cursor: pointer; flex-shrink: 0; }
.et-inline-label { font-size: .68rem; color: #64748b; cursor: pointer; white-space: nowrap; }
.et-line-check { display: inline-flex; align-items: center; gap: 5px; }

/* ─── File upload ─── */
.et-file-row { display: flex; align-items: center; gap: 10px; margin-top: .25rem; }
.et-file-label { cursor: pointer; padding: 6px 14px; border-radius: 6px; background: #fff; border: 1px solid #d1d5db; font-size: .78rem; font-weight: 700; font-family: marine, 'Inter', sans-serif; transition: background .15s; white-space: nowrap; }
.et-file-label:hover { background: #f8fafc; }
.et-file-hidden { display: none; }
.et-file-name { font-size: .75rem; color: #64748b; truncate: true; }

/* ─── Diseño grid ─── */
.et-design-grid { display: grid; grid-template-columns: 1fr 1fr; gap: .75rem; margin-top: .75rem; }
.et-design-field { display: flex; flex-direction: column; gap: 4px; }
.et-color-full { width: 100%; height: 38px; border: 1px solid #e2e8f0; border-radius: 8px; cursor: pointer; padding: 2px; }

/* ─── Botones ─── */
.et-form-actions { display: flex; justify-content: center; gap: 10px; }
.et-btn { display: inline-flex; align-items: center; gap: 7px; padding: 9px 20px; border-radius: 999px; font-family: marine, 'Inter', sans-serif; font-size: .83rem; font-weight: 700; cursor: pointer; border: 2px solid transparent; transition: background .2s, opacity .2s; white-space: nowrap; }
.et-btn:disabled { opacity: .4; cursor: not-allowed; }
.et-btn--primary { background: var(--c-primary); color: #fff; border-color: var(--c-primary); }
.et-btn--primary:not(:disabled):hover { background: #005570; border-color: #005570; }
.et-btn--outline { background: #fff; color: var(--c-primary); border-color: var(--c-primary); }
.et-btn--outline:not(:disabled):hover { background: rgba(0,59,76,.05); }
.et-btn--amber { background: #f59e0b; color: #fff; border-color: #f59e0b; }
.et-btn--amber:not(:disabled):hover { background: #d97706; }
.et-btn--green { background: #16a34a; color: #fff; border-color: #16a34a; }
.et-btn--green:not(:disabled):hover { background: #15803d; }
.et-btn--sm { padding: 6px 14px; font-size: .78rem; }

/* ─── Select / small label ─── */
.et-select { padding: 7px 10px; border: 1px solid #e2e8f0; border-radius: 8px; font-family: marine, 'Inter', sans-serif; font-size: .8rem; font-weight: 600; cursor: pointer; background: #fff; height: 36px; }
.et-select--flex { flex: 1; min-width: 0; }
.et-select--sm { width: 56px; height: 32px; padding: 4px 6px; }
.et-small-label { font-size: .72rem; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: #64748b; white-space: nowrap; }

/* ─── Preview column ─── */
.et-preview-col { grid-area: preview; display: flex; flex-direction: column; gap: 1rem; min-height: 0; }
.et-preview-header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: .75rem; }
.et-preview-title { font-size: 1.1rem; font-weight: 900; color: var(--c-primary); margin: 0; }
.et-preview-controls { display: flex; align-items: center; justify-content: flex-end; gap: 10px; flex-wrap: wrap; margin-left: auto; }
.et-cols-ctrl { display: flex; align-items: center; gap: 6px; }
/* Compartir solo existe en móvil (Web Share API) */
.et-share-btn { display: none; }

/* ─── Cards grid ─── */
.et-cards-grid { display: flex; flex-wrap: wrap; gap: 1rem; justify-content: center; min-height: 200px; align-content: flex-start; }
.et-card-wrap { display: flex; flex-direction: column; align-items: center; max-width: 100%; }
/* La etiqueta conserva su tamaño real en cm; si excede la pantalla, se desplaza horizontalmente */
.et-card-scroll { max-width: 100%; overflow-x: auto; padding: 4px; }

/* ─── Card ─── */
.et-card { position: relative; display: flex; border-radius: 1rem; overflow: hidden; border: 4px solid; box-shadow: 0 4px 12px -2px rgba(0,0,0,.15); transition: transform .2s; background-size: 10px 10px; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
.et-card:not(.et-card--draft):hover { transform: scale(1.03); }
.et-card--draft { opacity: .5; outline: 2px dashed var(--c-coral, #ed8f7b); outline-offset: 3px; }
.et-card--editing { outline: 2px solid var(--c-primary); outline-offset: 3px; }
.et-draft-hint { font-size: .68rem; color: var(--c-coral, #ed8f7b); font-weight: 700; margin-top: 4px; }

/* ─── Card internals ─── */
.et-card-img { width: 33.333%; flex-shrink: 0; height: 100%; }
.et-card-img img { width: 100%; height: 100%; object-fit: cover; }
.et-card-text { flex: 1; padding: 8px; display: flex; flex-direction: column; justify-content: center; overflow: hidden; }
.et-card-text--full { width: 100%; }
.et-card-row { margin: 1px 0; white-space: normal; word-break: break-word; }
.et-blank-line { flex: 1; border-bottom: 1.5px solid currentColor; min-width: .5cm; }

/* ─── Barra de controles (fuera del contorno de la etiqueta) ─── */
.et-card-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 8px; width: 100%; max-width: 100%; box-sizing: border-box; margin-bottom: 6px; padding: 4px 8px; background: #f8fafc; border: 1px solid var(--c-border, #e8e4df); border-radius: 999px; }
.et-card-toolbar--draft { justify-content: center; }
.et-toolbar-group { display: flex; gap: 4px; }
.et-toolbar-size { font-size: .68rem; font-weight: 700; color: #64748b; white-space: nowrap; }
.et-icon-btn { background: #fff; border: 1px solid #d1d5db; border-radius: 8px; min-width: 30px; height: 30px; font-size: .85rem; line-height: 1; padding: 3px 6px; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; transition: background .15s, opacity .15s; }
.et-icon-btn:hover:not(:disabled) { background: #f1f5f9; }
.et-icon-btn:disabled { opacity: .3; cursor: not-allowed; }
.et-icon-btn--danger:hover:not(:disabled) { background: #fee2e2; border-color: #fca5a5; }

/* ─── FAB Agregar (solo móvil) ─── */
.et-fab-wrap { display: none; }
.et-fab { width: 56px; height: 56px; border-radius: 50%; border: none; background: var(--c-primary, #003b4c); color: #fff; font-size: 1.3rem; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 6px 20px rgba(0,0,0,.32); transition: background .2s, opacity .2s; }
.et-fab:disabled { opacity: .45; cursor: not-allowed; }
.et-fab--cancel { width: 44px; height: 44px; font-size: 1rem; background: #fff; color: var(--c-primary, #003b4c); border: 2px solid var(--c-primary, #003b4c); }

/* ─── Indicador de scroll del formulario (solo móvil) ─── */
.et-scroll-hint { display: none; }

/* ─── Empty state ─── */
.et-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; padding: 3rem; color: #94a3b8; gap: .75rem; }
.et-empty i { font-size: 2.5rem; opacity: .4; }
.et-empty p { font-size: .9rem; margin: 0; }

/* ─── Print container ─── */
.et-print-container { display: none; }
/* Durante la captura para compartir se renderiza fuera de pantalla */
.et-print-container--capture { display: grid !important; position: fixed; left: -10000px; top: 0; background: #fff; gap: .5rem; padding: .5cm; }

/* ─── Responsive ─── */

/* Escritorio ≥1024px: alto fijo de viewport. Con `min-height` la página crecía con
   el contenido y ningún `flex: 1` llegaba a tener un alto definido contra el cual
   desplazarse; con `height` la cadena queda acotada y cada columna hace su scroll. */
@media (min-width: 1024px) {
  .et-page { height: 100vh; }
  .et-page-body { display: flex; flex-direction: column; }
  .et-layout { flex: 1; min-height: 0; }
  /* El formulario ocupa su fila y desplaza por dentro */
  .et-panel { align-self: stretch; }
  /* La vista previa abarca ambas filas; las tarjetas desplazan dentro de ella */
  .et-preview-col { align-self: stretch; }
  .et-cards-grid { flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; padding: 2px 6px 2px 2px; }
}

/* Tablet 769–1023px: una columna, la vista previa queda entre el topbar y el formulario */
@media (max-width: 1023px) {
  .et-layout { grid-template-columns: 1fr; grid-template-rows: none; grid-template-areas: "tpl" "preview" "form"; }
  .et-panel { max-height: none; overflow-y: visible; }
}

/* Mobile ≤768px: vista previa fija con scroll interno; el formulario hace scroll aparte */
@media (max-width: 768px) {
  .et-page-header { padding: .55rem 0; }
  .et-page-header--scrolled { padding: .4rem 0; }
  .et-page-heading { font-size: 1.05rem; }
  .et-page-desc, .et-page-chip { display: none; }
  .et-back-btn { width: 38px; height: 38px; font-size: .85rem; }
  .et-body-wrap { flex: none; padding: 0.5rem; }
  .et-page-body { flex: none; overflow: visible; padding: 1rem; border-radius: 12px; }
  .et-layout { gap: 0.75rem; }
  .et-topbar { padding: 1rem 1.25rem; }

  /* Vista previa: se ve una etiqueta y se hace scroll vertical para las demás */
  .et-preview-col { max-height: 40vh; max-height: 40dvh; gap: 0.5rem; }
  .et-cards-grid { flex-direction: column; flex-wrap: nowrap; align-items: center; justify-content: flex-start; flex: 1; min-height: 120px; overflow-y: auto; }
  .et-card-wrap { flex-shrink: 0; }

  /* Cabecera: título centrado; solo Compartir + Imprimir (solo iconos) a la derecha */
  .et-desktop-only { display: none !important; }
  .et-share-btn { display: inline-flex; }
  .et-preview-title { width: 100%; text-align: center; }
  .et-preview-controls { flex-wrap: nowrap; }
  .et-preview-controls .et-btn-label { display: none; }
  .et-preview-controls .et-btn { padding: 9px 13px; }

  /* Formulario: se ven ~2 fieldsets y el resto con scroll interno,
     sin mover la vista previa */
  .et-panel { max-height: 60vh; max-height: 60dvh; overflow-y: auto; padding: 1rem 1.25rem; }

  /* Acordeón de pasos: solo el paso abierto muestra su contenido */
  .et-legend { cursor: pointer; width: 100%; }
  .et-legend-chevron { display: inline-block; margin-left: auto; font-size: .7rem; transition: transform .2s; }
  .et-fieldset:not(.et-fieldset--collapsed) .et-legend-chevron { transform: rotate(180deg); }
  .et-fieldset--collapsed .et-form-fields,
  .et-fieldset--collapsed .et-design-grid { display: none; }

  /* Controles de estilo por campo colapsados tras el botón "Aa" */
  .et-style-toggle { display: inline-flex; align-items: center; gap: 5px; min-width: 44px; height: 28px; padding: 0 8px; justify-content: center; border: 1px solid #d1d5db; border-radius: 6px; background: #fff; font-size: .72rem; font-weight: 800; color: #64748b; cursor: pointer; flex-shrink: 0; }
  .et-style-toggle i { font-size: .55rem; transition: transform .2s; }
  .et-style-toggle--active { background: rgba(0,59,76,.1); color: var(--c-primary); border-color: var(--c-primary); }
  .et-style-toggle--active i { transform: rotate(180deg); }
  .et-field-block:not(.et-field-block--open) .et-field-adv { display: none; }
  .et-field-block--open .et-field-adv { margin-top: .2rem; }

  /* Fila de controles estable: color | alineación | tamaño, sin wrap irregular */
  .et-ctrl-row { display: grid; grid-template-columns: auto 1fr auto; justify-items: center; }
  .et-ctrl-row--show { display: flex; }

  /* Agregar/Cancelar viven en el FAB flotante */
  .et-form-actions { display: none; }
  .et-fab-wrap { display: flex; position: fixed; right: 16px; bottom: 16px; z-index: 60; flex-direction: column; align-items: center; gap: 10px; }

  /* Indicador de que el formulario es scrolleable */
  .et-scroll-hint { display: flex; position: sticky; bottom: 0; align-items: center; justify-content: center; gap: 6px; margin: -1.5rem -1.25rem -1rem; padding: 1.6rem 0 .5rem; background: linear-gradient(to bottom, rgba(255,255,255,0), #fff 65%); color: var(--c-primary, #003b4c); font-size: .7rem; font-weight: 800; pointer-events: none; }
  .et-scroll-hint i { animation: et-bounce 1.6s infinite; }

  /* 16px evita el auto-zoom de iOS al enfocar inputs */
  .et-input, .et-select { font-size: 16px; }
  /* Objetivos táctiles más grandes */
  .et-size-btn { width: 30px; height: 30px; }
  .et-align-btn { width: 34px; height: 30px; }
  .et-icon-btn { min-width: 36px; height: 36px; }
  .et-collapse-btn { width: 30px; height: 30px; }
  .et-color-pick { width: 40px; height: 40px; }
  .et-checkbox { width: 16px; height: 16px; }
}

@keyframes et-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(4px); }
}
@media (prefers-reduced-motion: reduce) {
  .et-scroll-hint i { animation: none; }
}

/* Small phones ≤480px */
@media (max-width: 480px) {
  .et-page-header-inner { padding: 0 14px; }
  .et-body-wrap { padding: 0.375rem; }
  .et-page-body { padding: 0.875rem; border-radius: 10px; }
  .et-design-grid { grid-template-columns: 1fr 1fr; }
  /* Plantilla a ancho completo y "Aleatorio" debajo */
  .et-template-row { flex-direction: column; align-items: stretch; }
  .et-template-row .et-btn { justify-content: center; }
  .et-cards-grid { gap: 0.75rem; }
}

/* ─── Impresión ─── */
@media print {
  .et-page { padding-top: 0 !important; background: #fff !important; height: auto !important; }
  .et-page-header { display: none !important; }
  .et-body-wrap { padding: 0 !important; display: block !important; }
  .et-page-body { display: none !important; }
  .et-print-container {
    display: grid !important;
    gap: .5rem;
    padding: .5cm;
  }
  .et-card { box-shadow: none !important; border: 2px solid #ccc !important; page-break-inside: avoid; transform: none !important; }
  .et-icon-btn { display: none !important; }
  .et-fab-wrap { display: none !important; }
}
</style>
